import { convertToPubNubTimetoken } from "./types";
export function pubnubRange({ end, start }) {
    const endTime = convertToPubNubTimetoken(end);
    const startTime = convertToPubNubTimetoken(start);
    const endTimeIsBigInt = typeof endTime === "bigint";
    const startTimeIsBigInt = typeof startTime === "bigint";
    if ((endTimeIsBigInt && endTime < 0) ||
        (startTimeIsBigInt && startTime < 0) ||
        (endTimeIsBigInt && startTimeIsBigInt && endTime > startTime)) {
        throw new Error(`Invalid range, end=${endTime}, start=${startTime}`);
    }
    return {
        end: endTime,
        start: startTime,
    };
}
